import { Link } from 'react-router';

import {
  BreadcrumbProps,
  Breadcrumbs as CfaBreadcrumbs,
} from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

import { Breadcrumb } from '@/types/types';

interface BreadcrumbLinksProps {
  breadcrumbs: Breadcrumb[];
  className?: string;
  'data-testid'?: string;
  onClick?: () => void;
}

const BreadcrumbLinks: React.FC<BreadcrumbLinksProps> = ({
  breadcrumbs,
  className,
  'data-testid': DataTestId,
  onClick,
}) => {
  const mapBreadCrumbsToLinks = (): BreadcrumbProps[] =>
    breadcrumbs.map((breadcrumb): BreadcrumbProps => {
      const base: BreadcrumbProps = {
        label: breadcrumb.label ?? '',
        onClick: breadcrumb.onClick,
      };
      if (breadcrumb.to) {
        return { ...base, to: breadcrumb.to, as: Link };
      }
      return base;
    });

  const mappedBreadcrumbs = mapBreadCrumbsToLinks();

  return (
    <div
      className={cn('flex w-full flex-col items-start', className)}
      data-testid={DataTestId}
    >
      {breadcrumbs.length > 0 && (
        <CfaBreadcrumbs
          className="[&_a]:capitalize! [&_button]:capitalize! [&_p]:capitalize!"
          breadcrumbs={mappedBreadcrumbs}
          onClick={onClick}
          overrideMarginLeft
        />
      )}
    </div>
  );
};

export default BreadcrumbLinks;
